export const patientServicesTipsModal = (isLargeScreen: boolean) => ({
	left: '50%',
	bottom: isLargeScreen ? 'auto' : 0,
	top: isLargeScreen ? '50%' : 'auto',
	transform: isLargeScreen ? 'translate(-50%, -50%)' : 'translateX(-50%)',

	padding: '1.5rem',
	maxWidth: '37.5rem',
	boxSizing: 'border-box',
	width: isLargeScreen ? 'min(100vw - 2.5rem, 37.5rem)' : '100%',

	gap: '1.5rem',
	display: 'flex',
	position: 'absolute',
	flexDirection: 'column',

	backgroundColor: 'backgrounds.white',
	boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.25)',
	borderRadius: isLargeScreen ? '1.25rem' : '1.25rem 1.25rem 0 0',
});

export const patientServicesTipsHeader = {
	gap: '0.5rem',
	display: 'flex',
	justifyContent: 'space-between',
};

export const patientServicesCloseButton = {
	borderRadius: '50%',
	border: '1px solid #AFAFAF',

	padding: '0.5rem',
	fontSize: '1.25rem',

	cursor: 'pointer',
	transition: 'background-color 0.2s ease, border-color 0.2s ease',

	'&:hover': {
		backgroundColor: '#AFAFAF',
	},
};

export const patientServicesTipsModalSection = {
	gap: '1rem',
	display: 'flex',
	flexDirection: 'row',
};

export const patientServicesTipsModalContent = {
	gap: '0.5rem',
	display: 'flex',
	textAlign: 'left',
	flexDirection: 'column',
	alignItems: 'flex-start',
};

export const patientServicesTipsModalButton = {
	alignSelf: 'center',
	width: 'fit-content',
};

export const patientServicesTipsModalNumber = {
	color: 'white',

	width: '2rem',
	height: '2rem',
	minWidth: '2rem',
	minHeight: '2rem',
	flex: '0 0 2rem',
	flexShrink: 0,

	borderRadius: '50%',
	backgroundColor: '#282828',
	border: '1px solid #282828',

	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

export const patientServicesContainer = {
	gap: '1.25rem',
	display: 'flex',
	textAlign: 'center',
	alignItems: 'center',
	flexDirection: 'column',

	width: 'min(100%, 40rem)',
	maxWidth: '40rem',
	boxSizing: 'border-box',
	margin: '2rem auto',
	padding: '1.25rem 1.25rem 2.75rem 1.25rem',
};

export const patientServicesSection = {
	width: '100%',
	gap: '1.25rem',
	display: 'flex',
	padding: '1.5rem',
	alignSelf: 'stretch',
	alignItems: 'center',
	flexDirection: 'column',

	borderRadius: '1.25rem',
	backgroundColor: 'backgrounds.white',
};

export const patientServicesEmail = {
	width: '100%',
	maxWidth: '25rem',

	'& .MuiOutlinedInput-root': {
		height: '3.75rem',
		borderRadius: '0.75rem',
	},
};

export const patientServicesSpinner = (color: string) => ({
	color: color,
	marginRight: '1rem',
});

export const patientServicesTips = {
	display: 'flex',
	color: '#282828',
	alignItems: 'center',
	flexDirection: 'row',
};
